module.exports = __webpack_public_path__ + "media/images/icon/category-9312a38ca4097081583adce970545282.svg";